import { render, staticRenderFns } from "./BasicStepperWrapper.vue?vue&type=template&id=61139d1e&"
import script from "./BasicStepperWrapper.vue?vue&type=script&lang=ts&"
export * from "./BasicStepperWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports